import cx from 'clsx';
import React from 'react';
import { type Control, useController } from 'react-hook-form';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

type RadioOptionsType = 'row' | 'column';
type RadioSizeType = 'small' | 'full';

interface IProps {
  name: string;
  control: Control<any>;
  label?: string;
  size?: RadioSizeType;
  type?: RadioOptionsType;
  required?: boolean;
  options: {
    value: number | string;
    label: string;
    disabled?: boolean;
  }[];
  className?: string;
  woHelperText?: boolean;
}

const RadioButtonsGroup = ({
  name,
  control,
  label,
  options = [],
  type = 'row',
  size,
  required,
  className = '',
  woHelperText = false,
}: IProps) => {
  const { t } = useTranslation();

  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <div className={className}>
      {label && (
        <label className={cx(style.radioBtnsLabel, { [style.required]: required })}>{t(label)}</label>
      )}
      {!!options.length && (
        <div id={name} className={cx(style.radioBtnsWrapper, { [style.directionColumn]: type === 'column' })}>
          {options.map((option) => (
            <label
              key={option.value}
              className={cx(style.radioItem, {
                [style.radioItemSmall]: size === 'small',
                [style.radioItemFull]: size === 'full',
                [style.radioItemDisabled]: option.disabled,
              })}
              onClick={() => onChange(option.value)}
            >
              <div className={style.itemBtn}>
                <input
                  name={name}
                  type="radio"
                  className={style.itemInput}
                  value={option.value}
                  defaultChecked={option.value === value}
                />
                <span
                  className={cx(style.itemIcon, {
                    [style.itemChecked]: option.value === value,
                  })}
                />
              </div>
              <span
                className={cx(style.labelText, {
                  [style.labelItemChecked]: option.value === value,
                })}
              >
                {t(option.label)}
              </span>
            </label>
          ))}
        </div>
      )}
      {!woHelperText && <div className={style.helperText}>{error && t(error?.message)}</div>}
    </div>
  );
};

export default RadioButtonsGroup;
